import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!target) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  const ms = target ? new Date(target).getTime() - now : 0;
  if (!target || Number.isNaN(ms) || ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

function Unit({ v, l }) {
  return (
    <span className="flex flex-col items-center rounded-xl bg-white/15 px-2.5 py-1 backdrop-blur">
      <span className="font-display text-lg font-semibold tabular-nums leading-none">{String(v).padStart(2, "0")}</span>
      <span className="mt-0.5 text-[9px] uppercase tracking-wider opacity-80">{l}</span>
    </span>
  );
}

export function SaleBadge({ sale }) {
  if (!sale?.active) return null;
  return (
    <span data-testid="sale-badge" className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#FF9F0A] to-[#FF2D55] px-2.5 py-1 text-[11px] font-bold tracking-wide text-white">
      <Sparkle size={11} weight="fill" /> {sale.code} · {sale.percent}% OFF
    </span>
  );
}

export function SaleBanner({ sale, cta = true }) {
  const left = useCountdown(sale?.countdown_to);
  if (!sale?.active) return null;
  return (
    <div data-testid="sale-banner" className="relative overflow-hidden bg-gradient-to-r from-[#FF9F0A] via-[#FF6A3D] to-[#FF2D55] text-white">
      <div className="pointer-events-none absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 10% 50%, #fff3 0 2px, transparent 3px), radial-gradient(circle at 80% 30%, #fff3 0 2px, transparent 3px)", backgroundSize: "60px 60px" }} />
      <div className="relative mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 sm:px-8 sm:py-3">
        <p className="flex min-w-0 items-center gap-2 text-left text-xs font-medium sm:text-sm">
          <Sparkle size={16} weight="fill" className="shrink-0" aria-hidden />
          <span data-testid="sale-banner-short" className="truncate sm:hidden"><b>{sale.name}</b> · {sale.percent}% off{left && <span className="tabular-nums opacity-90"> · ends in {left.d}d {left.h}h</span>}</span>
          <span className="hidden sm:inline"><b>{sale.name}</b> · {sale.percent}% off every plan, monthly & yearly · code <b className="rounded bg-white/20 px-1.5 py-0.5 font-mono">{sale.code}</b> applied automatically</span>
        </p>
        <div className="flex shrink-0 items-center gap-3">
          {left && (
            <div className="hidden items-center gap-1.5 sm:flex" data-testid="sale-countdown">
              <span className="mr-1 whitespace-nowrap text-[11px] font-medium opacity-90">Diwali in</span>
              <Unit v={left.d} l="days" /><Unit v={left.h} l="hrs" /><Unit v={left.m} l="min" /><Unit v={left.s} l="sec" />
            </div>
          )}
          {cta && (
            <Link to="/pricing" data-testid="sale-banner-cta" className="flex items-center gap-1 whitespace-nowrap rounded-full bg-white px-3.5 py-1.5 text-xs font-semibold text-[#E0431F] hover:bg-white/90">
              <span className="sm:hidden">Get deal</span><span className="hidden sm:inline">Grab the deal</span> <ArrowRight size={12} weight="bold" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
